"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var shared_1 = require("./shared");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var messages = __importStar(require("../translations"));
exports.Skeleton = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, height = _a.height, _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.borderRadius, borderRadius = _c === void 0 ? 0 : _c, _d = _a.preset, preset = _d === void 0 ? 'normal' : _d, testId = _a.testId, ariaLabel = _a.ariaLabel, props = __rest(_a, ["className", "height", "width", "borderRadius", "preset", "testId", "ariaLabel"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var presetValue = selectedTheme === 'dark' ? 'darkest' : preset;
    var classes = (0, css_1.cx)((0, shared_1.skeletonStyles)({ height: height, width: width, borderRadius: borderRadius, preset: presetValue }), shared_1.keyframesCss, className, 'ds-skeleton');
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    return (react_1.default.createElement("div", __assign({ className: classes, ref: ref, "data-testid": testId, "aria-label": ariaLabel || formatMessage(messages, 'loading'), "aria-busy": "true", role: "status" }, props)));
});
exports.Skeleton.displayName = 'Skeleton';
